import { colors, gap, media, spacing, Typography } from '@lamimed/pantheon';
import styled from 'styled-components';

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled(Typography)`
  word-break: normal;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  ${gap(spacing.small)};

  ${media.lessThan('tablet')`
    p {
      font-weight: 300;
    }
  `};
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${spacing.medium};
  margin-bottom: ${spacing.large};
  align-items: start;

  ${media.greaterThan('tablet')`
    justify-content: space-around;
  `}
`;

export const Circle = styled.div`
  width: 6.5rem;
  height: 6.5rem;
  border-radius: 50%;
  background-image: ${colors.gradient__primary_diagonal};
  margin-bottom: ${spacing.medium};
  display: flex;
  align-items: center;
  justify-content: center;
`;
